import { useMutation } from '@vue/apollo-composable';
import { useI18n } from 'vue-i18n';
import { flash } from '@/helpers/ui';
import { UPDATE_STOCK_ORDER } from './graphql';

export default function useUpdateNote() {
  const { mutate } = useMutation(UPDATE_STOCK_ORDER);
  const { t } = useI18n();

  const updateNote = (
    id: number,
    notes: string,
    status: string,
    action: 'create' | 'edit' | 'delete',
  ) => {
    mutate(
      {
        input: {
          id,
          notes,
          status,
        },
      },
      {
        update(cache) {
          const cacheId = `StockOrder:${id}`;
          cache.evict({ id: cacheId, broadcast: false });
          cache.evict({ id: 'ROOT_QUERY', fieldName: 'stockOrders' });
          cache.gc();
        },
      },
    ).then(() => {
      let noteAction;
      switch (action) {
        case 'edit':
          noteAction = 'note_updated';
          break;
        case 'create':
          noteAction = 'note_created';
          break;
        default:
          noteAction = 'note_deleted';
      }
      flash(t(`global.flash.${noteAction}`));
    });
  };

  return {
    updateNote,
  };
}
